import styled from 'styled-components';
import Button from '../../Button/Button.es.js';
import '../../../utils/assertions.es.js';
import 'react';
import '../../../utils/responsive.es.js';
import '../../../utils/scrollIntoView.es.js';
import { palette, fontWeight, spacing } from '../../../utils/theme.es.js';
import '../../../utils/useEnhancedEffect.es.js';
import 'react-is';

const SelectedFilterItem = styled(Button)`
    /* we need max-width not to break layout on mobiles in case tag name will be too long */
    max-width: 300px;
    -webkit-font-smoothing: antialiased;
    background-color: ${palette("neutral.800")};
    font-weight: ${fontWeight("regular")};
    margin-bottom: ${spacing("md")};
    svg {
        color: ${palette("neutral.400")};
    }
    &:hover {
        background-color: ${palette("neutral.600")};
    }
`;

export { SelectedFilterItem };
//# sourceMappingURL=SelectedFilters.es.js.map
